import React from "react";
import { View, StyleSheet, TouchableHighlight, Text } from "react-native";
import Modal from "react-native-modal";

const ModalDefault = (props) => {
  return (
    <Modal
      backdropTransitionOutTiming={0}
      isVisible={props.isVisible}
      useNativeDriver
      backdropColor={"black"}
      backdropOpacity={0.5}
      animationIn={"zoomInDown"}
      animationOut={"zoomOutUp"}
      animationInTiming={1000}
      animationOutTiming={1}
      backdropTransitionInTiming={1000}
      // backdropTransitionOutTiming={1000}
    >
      <View style={styles.modalContent}>
        <Text>{props.textMain}</Text>
        <TouchableHighlight onPress={props.onPress}>
          <View>
            <Text>{props.textAction}</Text>
          </View>
        </TouchableHighlight>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContent: {
    backgroundColor: "white",
    padding: 22,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderColor: "rgba(0, 0, 0, 0.1)",
  },
});

export { ModalDefault };
